import React, { useEffect } from "react";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
 
export const CommunityLiaisonField = ({
  formData,
  onChange,
  formContext,
  rawErrors = [],
  uiSchema,
  required,
}) => {
  const {
    cityLiaisonMapping = {},
    setFormData,
    formData: rootFormData,
    isCityLiaisonMappingCalled
  } = formContext || {};
 
  const liaisonEntries = Object.entries(cityLiaisonMapping);
  const validLiaisons = Object.values(cityLiaisonMapping);
 
  // Label
  const baseLabel =
    uiSchema?.["ui:options"]?.label || "Select Community Liaison";
  const label = required ? `${baseLabel} *` : baseLabel;
 
  useEffect(() => {
    if(isCityLiaisonMappingCalled && formData){
      if (cityLiaisonMapping && Object.keys(cityLiaisonMapping).length > 0) {
      // mapping available, check validity
        if (!validLiaisons.includes(formData)) {
          resetCommunityLiaison();
        }
      }else{
        resetCommunityLiaison();
      }
    }
  }, [cityLiaisonMapping, formData, validLiaisons]);
 
  const resetCommunityLiaison = () => {
    formContext.setFormData?.((prev) => ({
      ...prev,
      formSubmissionDetails: {
        ...prev.formSubmissionDetails,
        communityLiaison: "",
      },
    }));
    formContext.setFormDataVersion?.((v) => v + 1);
  };
 
  return (
    <FormControl fullWidth error={rawErrors?.length > 0}>
      <InputLabel id="community-liaison-label">{label}</InputLabel>
      <Select
        labelId="community-liaison-label"
        value={formData || ""}
        label={label}
        onChange={(e) => onChange(e.target.value)}
      >
        {liaisonEntries.map(([unqGuid, name]) => (
          <MenuItem key={unqGuid} value={name}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};